<template>
	<div class="link-form-column" :style="{width:width}" :class="classes">
		<slot></slot>
	</div>
</template>

<script>
    export default {
        name: "link-form-column",
        props: {
            width: {default: null},
            textAlign: {default: 'right'},
            labelWidth: {type: String, default: 'auto'},
        },
        provide() {
            return {
                formColumn: this,
            }
        },
        data() {
            return {
                formItems: [],
                maxLabelWidth: null,
            }
        },
        computed: {
            lv_labelWidth() {
                if (!this.labelWidth) return null
                if (this.labelWidth !== 'auto') return this.labelWidth
                return this.formItems.reduce((ret, item) => ret > item.labelWidth ? ret : item.labelWidth, 0)
            },
            classes() {
                return [
                    `link-form-column-text-${this.textAlign}`,
                    {
                        'link-form-column-auto-label-width': this.labelWidth == 'auto',
                    },
                ]
            },
        },
        methods: {
            addItem(item) {
                this.formItems.push(item)
            },
            removeItem(item) {
                const index = this.formItems.indexOf(item)
                if (index > -1) this.formItems.splice(index, 1)
            },
        }

    }
</script>

<style lang="scss">
	.link-form {
		.link-form-column {
			display: inline-flex;
			align-items: flex-start;
			justify-content: flex-start;
			flex-direction: column;
			box-sizing: border-box;
			margin-right: 12px;

			.link-form-item {
				& + .link-form-item {
					margin-left: 0 !important;
				}
			}

			.link-form-item {
				width: 100%;
			}

			&.link-form-column-text-left {
				.link-form-item-label {
					text-align: left !important;
				}
			}

			&.link-form-column-text-center {
				.link-form-item-label {
					text-align: center !important;
				}
			}

			&.link-form-column-text-right {
				.link-form-item-label {
					text-align: right !important;
				}
			}

			&.link-form-column-auto-label-width {
				.link-form-item-label {
					white-space: nowrap;
				}
			}
		}
	}
</style>
